import React from "react";
import { connect } from "react-redux";
import DataGrid, { Column } from "devextreme-react/ui/data-grid";
import LoadingGif from "../../../../../../images/animacion2[18].gif";
import UserInfoColumn from "../../../../../Shared/UserInfoColumn";
import { setSelectedWorkers } from "../actions";
import LoadingOverlay from "../../../../../Shared/LoadingOverlay";

class Trabajadores extends React.PureComponent {
  handleSelection = (e) => {
    this.props.dispatch(setSelectedWorkers(e.selectedRowsData));
  }

  render() {
    const _workers = this.props.dataSelected && this.props.dataSelected.Workers ? this.props.dataSelected.Workers : [];
    return (
      <React.Fragment>
        {this.props.isLoading && <LoadingOverlay />}
        <div
          className="row"
          style={{
            margin: "10px 0 10px 0",
            borderTop: "1px solid #ddd",
            paddingTop: 10,
          }}
        >
        </div>
        <div className="table-wrapper">
          <DataGrid
            activeStateEnabled={false}
            dataSource={_workers}
            showBorders={false}
            showColumnLines={false}
            showRowLines={false}
            className="custom-table"
            noDataText="Sin Trabajadores"
            rowAlternationEnabled
            hoverStateEnabled={false}
            selectedRowKeys={this.props.selectedWorkers}
            onSelectionChanged={this.handleSelection}
            selection={{
              showCheckBoxesMode: "always",
              mode: "multiple",
              allowSelectAll: false,
            }}
            loadPanel={{
              enabled: true,
              showPane: true,
              showIndicator: true,
              indicatorSrc: LoadingGif,
              text: "Cargando...",
            }}
            paging={{
              pageSize: 20,
            }}
            pager={{
              showInfo: true,
              visible:true,
              infoText: (page, total, items) => `Página ${page} de ${total} (${items} resultados)`
            }}
          // style={{ maxHeight: 256 }}
          >
            <Column
              caption="Trabajador"
              allowFiltering
              allowSearch={false}
              cellComponent={(row) => {              
                if(!row.data.DocumentNumber){
                  return (<UserInfoColumn
                    rut={""}
                    nombre={"SIN NOMBRE"}
                  />)
                }else{
                  return (
                  <UserInfoColumn
                    rut={row.data.DocumentNumber ? row.data.DocumentNumber : ""}
                    nombre={row.data.Name ? row.data.Name : ""}
                  />)
                }   
              }} 
            />

            <Column
              dataField="Phone"
              caption="Teléfono"
              allowFiltering={false}
              allowSearch={false}
              alignment="center"

            />
            <Column
              dataField="Mail"
              caption="Mail"
              allowFiltering
              allowSearch={false}
              alignment="center"

            />
          </DataGrid>
        </div>

      </React.Fragment>

    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.confirmacionSolicitudesAgendaSel.isLoading,
  dataSelected: state.confirmacionSolicitudesAgendaSel.dataSelected,
  selectedWorkers: state.confirmacionSolicitudesAgendaSel.selectedWorkers,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Trabajadores);
